import useSWR from 'swr'

import { FetchError } from '../../../../data/fetchError'
import { FetchResponse } from '../../../../data/fetchResponse'
import { FetchResult } from '../../../../data/fetchResult'
import { fetchJson } from '../../../../data/fetchers'
import {
  RoleAssignment,
  RoleAssignmentsWithProjectName,
  RoleSets,
  Roles,
} from './model'

// Get all role assignments
export function useAllRoleAssignments(): FetchResult<RoleAssignmentsWithProjectName> {
  const { data, error, isLoading, mutate } = useSWR<
    FetchResponse<RoleAssignmentsWithProjectName>,
    FetchError
  >(
    '/selfservices/suppliers/roleassignments',
    fetchJson<RoleAssignmentsWithProjectName>,
  )

  return {
    data: data?.body,
    isLoading,
    error,
    mutate,
  }
}

// Get role assignment by id
export function useRoleAssignmentById(
  roleAssignmentId: string,
): FetchResult<RoleAssignment> {
  const { data, error, isLoading, mutate } = useSWR<
    FetchResponse<RoleAssignment>,
    FetchError
  >(
    `/selfservices/suppliers/roleassignments/${roleAssignmentId}`,
    fetchJson<RoleAssignment>,
  )

  return {
    data: data?.body,
    isLoading,
    error,
    mutate,
  }
}

// Get all roles
export function useAllRoles(): FetchResult<Roles> {
  const { data, error, isLoading, mutate } = useSWR<
    FetchResponse<Roles>,
    FetchError
  >('/selfservices/suppliers/roles', fetchJson<Roles>)

  return {
    data: data?.body,
    isLoading,
    error,
    mutate,
  }
}

// Get all role sets
export function useAllRoleSets(isBuyer = false): FetchResult<RoleSets> {
  const { data, error, isLoading, mutate } = useSWR<
    FetchResponse<RoleSets>,
    FetchError
  >(`/selfservices/suppliers/rolesets?isBuyer=${isBuyer}`, fetchJson<RoleSets>)

  return {
    data: data?.body,
    isLoading,
    error,
    mutate,
  }
}
